import { render, staticRenderFns } from "./MsgInfo.vue?vue&type=template&id=24353d6a&scoped=true&"
import script from "./MsgInfo.vue?vue&type=script&lang=js&"
export * from "./MsgInfo.vue?vue&type=script&lang=js&"
import style0 from "./MsgInfo.vue?vue&type=style&index=0&id=24353d6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24353d6a",
  null
  
)

export default component.exports